import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonChartComponent } from './common-chart.component';
import { ChartModule } from 'primeng/chart';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
  declarations: [CommonChartComponent],
  imports: [
    CommonModule,
    ChartModule,
    CardModule,
    DropdownModule
  ],
  exports: [CommonChartComponent]
})
export class CommonChartModule { }